import $ from 'jquery';
import { getSingleValueFromInput } from './utils';
import ZhongXuan from './ZhongXuan';

export default function trackArticleDetailPageView() {
  const articleId = getSingleValueFromInput('newsId');

  if (!articleId) {
    return;
  }

  const contentType = getSingleValueFromInput('contentType');

  const contentTypeMap: Record<string, string> = {
    '1': '文章',
    '2': '图片',
    '4': '视频',
    '5': '音频',
    '6': '专题',
    '7': '直播',
  };

  // const mediaNames = $('.media-name')
  //   .map((_, el) => $(el).text().trim())
  //   .get()
  //   .filter(Boolean)
  //   .join('、');

  // const articleAuthor =
  //   mediaNames ||
  //   $('.article-source')
  //     .text()
  //     .replace(/^来源：/, '')
  //     .trim() ||
  //   '';

  // 发布时间多源兜底：
  // 图文/音频/视频用 .article-time；直播用 .live-time；
  // 图集等无时间元素，用 meta[property="article:published_time"]。
  const timeText =
    $('.article-time').text().trim() ||
    $('.live-time').text().trim() ||
    document
      .querySelector('meta[property="article:published_time"]')
      ?.getAttribute('content')
      ?.trim() ||
    '';
  let currentCreateDate = '';
  if (timeText) {
    const date = new Date(timeText.replace(/-/g, '/'));
    if (!Number.isNaN(date.getTime())) {
      currentCreateDate = String(date.getTime());
    }
  }

  const originalityValue = getSingleValueFromInput('isOriginal');
  const originality = originalityValue === '1' ? '是' : '否';

  const specialTopicName = getSingleValueFromInput('specialTopicName') || '';

  // 稿件标题多源兜底：
  // 图文/音频用 #article-title；视频/图集/直播/专题等无该元素，用 shareTitle（hidden 字段）；
  // 直播还有 .live-title；最后兜底 document.title，避免 article_name 为空。
  const articleName =
    $('#article-title').text().trim() ||
    getSingleValueFromInput('shareTitle') ||
    $('.live-title').text().trim() ||
    document.title ||
    '';

  // 作者/来源多源兜底：#article-source、.article-source、.live-source 等
  const author =
    getSingleValueFromInput('author') ||
    $('.article-source')
      .text()
      .replace(/^来源：/, '')
      .trim() ||
    $('.live-source').text().trim() ||
    '';

  // 页面名称：专题页显示"专题列表页"，其余类型统一为"稿件详情页"
  const pageName = contentType === '6' ? '专题列表页' : '稿件详情页';

  ZhongXuan.pageView({
    event_code: 'article_details_pg',
    current_page_name: pageName,
    current_page_id: 'article_details_pg',
    article_id: articleId,
    article_name: articleName,
    article_type: contentTypeMap[contentType] || contentType || '',
    article_author: author,
    current_create_date: currentCreateDate,
    originality,
    special_topic_name: specialTopicName,
  });
}
